/**
 * This file is part of "Zona franca"
 * Copyright (c) 2022
 * Zona franca
 * All rights reserved
 *
 * @author Turiano Romero <https://bitbucket.org/rome9603/ | tromero@technisupport.com>
 * @version 2.0
 */

import { securityTypes } from "redux/types";

const setDataVetaTruck = (payload) => {
  return {
    type: securityTypes.setDataTruck,
    payload
  };
};

const setDataVetaPerson = (payload) => {
  return {
    type: securityTypes.setDataVetaPerson,
    payload
  };
};

const setDataVetaDriver = (payload) => {
  return {
    type: securityTypes.setDataVetaDriver,
    payload
  };
};

export { setDataVetaTruck, setDataVetaPerson, setDataVetaDriver };
